<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--md">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-hard-drive-2-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">Espace disque</h4>
                            <p class="cf-modal-head__sub">Stockage dédié aux photos des articles</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <template v-if="loading">
                        <p class="ed-loading"><i class="ri-loader-4-line ed-spin"></i> Chargement...</p>
                    </template>

                    <template v-else>

                        <!-- Barre -->
                        <div class="ed-bar">
                            <div class="ed-bar__fill" :class="{ 'ed-bar__fill--warn': quota.pourcentage >= 80 && !quota.atteint, 'ed-bar__fill--full': quota.atteint }" :style="{ width: quota.pourcentage + '%' }"></div>
                        </div>
                        <p class="ed-barlabel">{{ quota.pourcentage }} % utilisé</p>

                        <!-- Cartes -->
                        <div class="ed-cards">
                            <div class="ed-card">
                                <p class="ed-card__lbl">Espace total</p>
                                <p class="ed-card__val">{{ quota.maxMo }} <span>Mo</span></p>
                            </div>
                            <div class="ed-card">
                                <p class="ed-card__lbl">Utilisé</p>
                                <p class="ed-card__val ed-card__val--used">{{ quota.usedMo }} <span>Mo</span></p>
                            </div>
                            <div class="ed-card">
                                <p class="ed-card__lbl">Restant</p>
                                <p class="ed-card__val ed-card__val--rest">{{ resteAffiche }} <span>Mo</span></p>
                            </div>
                            <div class="ed-card">
                                <p class="ed-card__lbl">Photos stockées</p>
                                <p class="ed-card__val">{{ quota.nbFichiers }}</p>
                            </div>
                        </div>

                        <p v-if="quota.atteint" class="ed-warn"><i class="ri-error-warning-line"></i> Espace saturé : l'ajout de nouvelles photos est bloqué tant que de l'espace n'est pas libéré.</p>
                        <p v-else-if="quota.pourcentage >= 80" class="ed-note"><i class="ri-information-line"></i> Il vous reste peu d'espace disponible.</p>

                    </template>

                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="loadQuota" type="button" class="ti-btn ti-btn-primary-full" :disabled="loading"><i class="ri-refresh-line align-middle"></i> Actualiser</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


</template>

<script>

    const axios = require('axios');

    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "modalespacedisk",

        data() {
            return {
                isdisplay: false,
                loading: false,
                quota: { maxMo: 1, usedMo: 0, resteMo: 1, nbFichiers: 0, pourcentage: 0, atteint: false },
            };
        },

        computed: {
            resteAffiche() {
                let r = this.quota.resteMo;
                if (typeof r !== 'number') return 0;
                return r < 0 ? 0 : r;
            },
        },

        methods: {

            async loadQuota() {

                this.loading = true;

                const t = this;
                let url = process.env.VUE_APP_API_URL + '/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/photoarticle/quota/' + this.$store.state.appsociete + '/' + randomString();

                await axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                })
                    .then(function (res) {
                        if (res.data && res.data.success && res.data.quota) {
                            t.quota = res.data.quota;
                        }
                    })
                    .catch(function () { /* silencieux */ })
                    .finally(function () { t.loading = false; });

            },

            close() {
                this.isdisplay = false;
            },

            show() {
                this.isdisplay = true;
                this.loadQuota();
            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--md { max-width:520px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.ed-loading { display:flex; align-items:center; gap:0.5rem; color:var(--cf-muted); font-size:0.85rem; }
.ed-spin { animation:ed-rot 1s linear infinite; display:inline-block; }
@keyframes ed-rot { to { transform:rotate(360deg); } }

.ed-bar { height:12px; border-radius:999px; background:var(--cf-surface-alt); overflow:hidden; }
.ed-bar__fill { height:100%; background:rgb(var(--primary)); transition:width 0.3s ease; }
.ed-bar__fill--warn { background:#d97706; }
.ed-bar__fill--full { background:rgb(var(--danger)); }
.ed-barlabel { margin:0.4rem 0 1.1rem; font-size:0.78rem; color:var(--cf-muted); text-align:right; }

.ed-cards { display:grid; grid-template-columns:repeat(2, 1fr); gap:0.7rem; }
.ed-card { background:var(--cf-surface-alt); border-radius:var(--cf-radius-sm); padding:0.75rem 0.9rem; }
.ed-card__lbl { margin:0 0 0.25rem; font-size:0.72rem; color:var(--cf-muted); text-transform:uppercase; letter-spacing:0.03em; }
.ed-card__val { margin:0; font-size:1.3rem; font-weight:700; color:var(--cf-ink-strong); }
.ed-card__val span { font-size:0.8rem; font-weight:500; color:var(--cf-muted); }
.ed-card__val--used { color:rgb(var(--primary)); }
.ed-card__val--rest { color:#059669; }

.ed-warn { margin:1rem 0 0; font-size:0.8rem; color:rgb(var(--danger)); display:flex; align-items:center; gap:0.35rem; }
.ed-note { margin:1rem 0 0; font-size:0.8rem; color:#b45309; display:flex; align-items:center; gap:0.35rem; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media screen and (max-width: 768px) {
    .cf-dialog--md { max-width:100%; }
    .ed-cards { grid-template-columns:1fr; }
}
</style>
